import React, { Component } from "react"
import { Link } from "gatsby"
import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import Hidden from "@material-ui/core/Hidden"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Grow from "@material-ui/core/Grow"
import Paper from "@material-ui/core/Paper"
import Popper from "@material-ui/core/Popper"
import MenuItem from "@material-ui/core/MenuItem"
import MenuList from "@material-ui/core/MenuList"
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"

import MenuIcon from "@material-ui/icons/Menu"
import ArrowDown from "@material-ui/icons/ArrowDropDown"
import ArrowUp from "@material-ui/icons/ArrowDropUp"

import store from "store"
import querystring from "querystring"

import CartButton from "./CartButton.js"

import HeaderLinkLists from "../../../Content/Data/HeaderLinkLists.js"
import GTLogo2 from "../../../Content/Images/Brand/GT-Logo.png"
import GTLogo3 from "../../../Content/Images/Brand/GTe-logo-white.svg"
import DefaultUserImage from "../../../Content/Images/PlaceHolders/graston_profile_no_photo.png"

import "./style.css"

const windowGlobal = typeof window !== "undefined" && window

const urlParams =
  windowGlobal &&
  windowGlobal.location &&
  querystring.parse(window.location.search)

export default class Header extends Component {
  state = {
    isMobileMenuOpen: false,
    joinOpen: false,
    userMenuOpen: false,
  }

  openMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  logout = () => {
    store.remove("tokens")
    store.remove("user")
    store.remove("newUserId")
    window.location.href = process.env.GATSBY_API_LOGOUT
  }

  openUserMenu = e => {
    this.setState({
      userMenuOpen: true,
      anchorEl: e.currentTarget,
    })
  }

  closeUserMenu = () => {
    this.setState({
      userMenuOpen: false,
    })
  }

  get userIsLoggedIn() {
    const { headerUserInfo } = this.props

    return headerUserInfo && headerUserInfo.userId != null
  }

  get userMenu() {
    const { userMenuOpen, anchorEl } = this.state
    return (
      <Popper open={userMenuOpen} anchorEl={anchorEl} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={this.closeUserMenu}>
                <MenuList>
                  <MenuItem onClick={this.logout}>Logout</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    )
  }

  get loggedInComponent() {
    const { userMenuOpen } = this.state
    const { headerUserInfo } = this.props

    const userImage =
      (headerUserInfo && headerUserInfo.userImageUrl) || DefaultUserImage

    return (
      <div className="user-menu-toggle-container">
        <div className="user-menu-wrapper">
          <Grid container alignItems="center">
            <Hidden mdDown>
              <Grid item xs={3}>
                <img className="user-menu-image" src={userImage} />
              </Grid>
            </Hidden>
            <Grid item xs={12} lg={9}>
              <button className="user-menu-toggle" onClick={this.openUserMenu}>
                <Grid container>
                  <Grid item xs={12}>
                    <span className="user-menu-username">
                      {headerUserInfo.userName}
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    {!userMenuOpen ? (
                      <ArrowDown className="expansion-arrow" />
                    ) : (
                      <ArrowUp className="expansion-arrow" />
                    )}
                  </Grid>
                </Grid>
              </button>
            </Grid>
          </Grid>
          {this.userMenu}
        </div>
      </div>
    )
  }

  getHeaderLinks = type => {
    switch (type) {
      case "clinicians":
      case "newClinicianHeader":
        return this.userIsLoggedIn
          ? HeaderLinkLists.loggedInClinicians
          : HeaderLinkLists.unLoggedInClinicians
      case "patients":
        return HeaderLinkLists.patients
      default:
        return this.userIsLoggedIn
          ? HeaderLinkLists.authHome
          : HeaderLinkLists.unauthHome
    }
  }

  linkToComponent = link => {
    if (link.hasOwnProperty("component")) {
      if (link.component.func) {
        return (
          <ListItem
            key={link.key}
            component={link.component.type}
            onClick={this[link.component.func]}
          >
            <ListItemText primary={link.name} />
          </ListItem>
        )
      }

      return (
        <ListItem
          key={link.key}
          component={link.component.type}
          {...link.component}
        >
          <ListItemText primary={link.name} />
        </ListItem>
      )
    }

    return (
      <ListItem key={link.key} component={Link} to={link.url}>
        <ListItemText primary={link.name} />
      </ListItem>
    )
  }

  openModal = () => {
    this.closeMobileMenu()
  }

  render() {
    const errorParameter = urlParams["?error"]

    const {
      headerUserInfo,
      typeOfHeader,
      itemsInCart,
      cart,
      displayClass,
    } = this.props

    const { isMobileMenuOpen } = this.state

    const headerLinks = this.getHeaderLinks(typeOfHeader)

    return (
      <div>
        <Hidden smDown>
          {(typeOfHeader === "newClinicianHeader") && (
            <div className="header-wrapper">
              <Grid container>
                <Grid item md={2} className="header-logo-wrapper">
                  <Link to="/" >
                    <img
                      src={GTLogo3}
                      id="header-logo-round"
                      alt="Graston Equine Logo"
                    />
                  </Link>
                </Grid>
                <Grid item md={6}>
                  <div className="nav-link-list-container">
                    <ul className="nav-link-list">
                      {headerLinks.map(
                        (headerLink, index) =>
                          !headerLink.mobileOnly && (
                            <li key={index} className="nav-link-item">
                              <Link
                                className={`nav-link ${windowGlobal.location &&
                                  windowGlobal.location.pathname ===
                                    headerLink.url &&
                                  "nav-link-selected"}`}
                                to={headerLink.url}
                              >
                                {headerLink.name}
                              </Link>
                            </li>
                          )
                      )}
                    </ul>
                  </div>
                </Grid>
                <Grid item md={4}>
                  <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className={`header-login-container ${displayClass}`}
                  >
                    <Grid item md={9} sm={10}>
                    {headerUserInfo && !headerUserInfo.userId && (
                        <div className="header-login-wrapper">
                          <a
                            className="white-rounded-button"
                            id="header-login-button2"
                            target="_blank"
                            href={process.env.GATSBY_PORTAL_SIGNIN_LINK}
                          >
                            PROVIDER LOGIN
                          </a>&nbsp;&nbsp;
                        </div>
                      )}
                      {this.userIsLoggedIn && this.loggedInComponent}
                    </Grid>
                    <Grid item md={3} sm={2}>
                      <CartButton itemsInCart={itemsInCart} cart={cart} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          )}
        </Hidden>

        <Hidden mdUp>
          <div className="small-header-wrapper">
            <Grid container>
              <Grid item xs={12} className="small-header-logo-wrapper">
                <Link to="/">
                  <img
                    src={GTLogo2}
                    id="header-logo"
                    alt="Graston Technique Logo"
                  />
                </Link>
              </Grid>
              <Grid item xs={12} className="mobile-menu-button">
                <div className="header-login-wrapper">
                  <IconButton aria-label="menu" onClick={this.openMobileMenu}>
                    <MenuIcon />
                  </IconButton>
                </div>
              </Grid>
            </Grid>
          </div>

          <Drawer
            anchor="right"
            open={isMobileMenuOpen}
            onClose={this.closeMobileMenu}
          >
            <List>
              {headerLinks.map(this.linkToComponent)}
              <Grid container justify="center">
                <CartButton itemsInCart={itemsInCart} cart={cart} />
              </Grid>
            </List>
          </Drawer>
        </Hidden>
      </div>
    )
  }
}
